import React from 'react';
import PropTypes from 'prop-types';
import Marquee from '../../components/Marquee';
import styles from './marqueeGroup.css';

const MarqueeGroup = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      {data.map(item => (
        <div key={item.quote}>
          <Marquee bg={item.bg} color={item.color} text={item.quote} />
        </div>
      ))}
    </div>
  );
};

MarqueeGroup.propTypes = {
  data: PropTypes.any.isRequired,
};

export default MarqueeGroup;
